import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Button, Img, Text } from "components";
import { TopHeader } from "components/Header/TopHeader";
import { NavMenu } from "components/Header/NavMenu";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
/**custom modules*/
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import * as CUSTOM from "../../utils/helper/custom";
import * as API from "../../utils/helper/Enum";
import { getAuth } from "../../redux/reducers/loginData";
import { useTranslation } from "react-i18next";
import { changeTrigger, currentTrigger } from "redux/reducers/trigger";
import { getDefaultLanguage } from "../../utils/helper/custom";
import { toggleHamburger } from "redux/reducers/uiSlice";
const Header = (props) => {
  let cpage = useLocation();
  const dispatch = useDispatch();
  const triggerValue = useSelector(currentTrigger);
  const guestId = CUSTOM.getDeviceID();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const auth = useSelector(getAuth);
  const [hamburger, setHamburger] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartData, setCartData] = useState(null);
  const [activeIcon, setActiveIcon] = useState(false);
  const [language, setLanguage] = useState(false);
  const hamburgerOpen = useSelector((state) => state.ui.hamburgerOpen);

  const loginData = CUSTOM.loginData();

  const isLoggedIn = !!loginData?.id;
  const userName = loginData?.firstName || "";

  const handleLogout = () => {
    localStorage.removeItem(storageKeys.USER_TOKEN);
    localStorage.removeItem(storageKeys.DEVICE_ID);

    localStorage.removeItem(storageKeys.CART_DATA);
    localStorage.removeItem(storageKeys.CART_COUNTER);

    dispatch(changeTrigger("loggedout"));
    window.location.href = "/";
  };

  /**
   * Dropdown menu
   */
  const handlehamburger = () => {
    setHamburger(!hamburger);
    dispatch(toggleHamburger());
    if (!hamburger) {
      document.body.classList.add("overflow-hidden");
      document.getElementById("header-box").classList.add("relative");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.getElementById("header-box").classList.remove("relative");
      document.getElementById("header-box").classList.remove("relative");
    }
  };

  const handlelanguage = () => {
    setLanguage(!language);
  };

  const enStyles = !language ? "hidden" : "block";

  /**
   * get cart count
   */
  const getCartCount = async () => {
    try {
      const authData = CUSTOM.loginData();
      const params = { user_id: authData?.id, guest_id: guestId };
      const { data } =
        (await globalRequest(
          API?.CART?.GET_CART_COUNT,
          "get",
          {},
          { params },
          true,
        )) || {};
      if (data?.status == "SUCCESS") {
        setCartCount(data?.data?.cartCount);
      }
    } catch (error) {
      console.error("Error in getCartCount:", error);
    }
  };

  // Example usage:
  // await getCartCount();

  /**
   * get cart data
   */
  const getCartData = async () => {
    try {
      dispatch(changeLoader(true));
      const authData = CUSTOM.loginData();
      const params = { user_id: authData?.id, guest_id: guestId };
      const { data } =
        (await globalRequest(
          API?.CART?.GET_CART_DATA,
          "get",
          {},
          { params },
          true,
        )) || {};
      if (data?.status === "SUCCESS") {
        let existingCart =
          addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "get") || [];
        if (!Array.isArray(existingCart)) {
          existingCart = [];
        }
        const updatedCart = data?.data?.cartItems?.map((item) => {
          const oldItem = existingCart.find((i) => i.id === item.id);
          return {
            ...item,
            addedAt: oldItem?.addedAt || item.addedAt || Date.now(),
          };
        });

        addDeleteGetLocalStorage(
          storageKeys?.CART_DATA,
          updatedCart,
          "add",
          "single",
        );
        setCartData(updatedCart);
      } else {
        addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "delete");
      }
      dispatch(changeTrigger("loadCartData"));
    } catch (error) {
      addDeleteGetLocalStorage(storageKeys?.CART_DATA, {}, "delete");
      dispatch(changeTrigger("loadCartData"));
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleCartClick = () => {
    cartData?.length > 0 &&
      CUSTOM.trackInitiateCheckout({
        value: cartData.reduce(
          (total, item) =>
            total + (item.productUom?.sellingPrice || 0) * (item.quantity || 1),
          0,
        ),
        items: cartData.length,
      });
    navigate("/cart");
  };

  useEffect(() => {
    let loginDatas = ["fetchCartCount", "loggedin"];
    if (loginDatas.includes(triggerValue)) {
      getCartData();
      getCartCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  useEffect(() => {
    getCartData();
    getCartCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let loginDatas = [
      "updateinlocal",
      "updateinlocal_langChg",
      "fetchCartCount",
      "loadSummay",
      "loadCartData",
      "loadAddressList",
      "loadGiftOccasionList",
      "loadAddressList",
    ];
    if (loginDatas.includes(triggerValue)) {
      setTimeout(() => {
        dispatch(changeTrigger(""));
      }, [500]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, [500]);
  }, [cpage]);

  /**
   * class set for menu
   */
  const hamburgerStyles = !hamburger ? "" : "is-active";
  const navStyles = !hamburger
    ? "sm:hidden"
    : "sm:flex absolute flex-col items-start bg-white z-[99999] right-0 top-full sm:w-screen bg-white-A700 overflow-auto header-height-xs p-4";

  return (
    <>
      <header
        id="header-box"
        className={`sticky top-0 z-30 bg-white-A700 flex flex-row font-nunitomedium  items-center justify-center shadow-bs w-full border border-bottom border-[#e6e6e6]`}
      >
        <div className="relative flex flex-row py-2 items-center sm:gap-2 gap-2 w-full justify-center sm:justify-between sm:mx-2 mx-0 top-2">
          {/* {cpage?.pathname != "/cart" ? ( */}
            <>
              <Img
                className="h-[6%] sm:h-[10%] sm:w-[15%] w-[8%]  cursor-pointer"
                src="/images/logo.svg"
                alt="rabbitholelogo"
                onClick={() => navigate("/")}
              />
              <NavMenu
                handlehamburger={handlehamburger}
                navStyles={`${navStyles}`}
              />
              <div className="flex flex-row items-center sm:justify-between justify-end sm:mx-0 sm:gap-4 gap-2 mx-4 py-2">
                <span
                  onClick={() => {
                    setActiveIcon(true);
                    handlelanguage();
                  }}
                  className={`
                      cursor-pointer
                      flex items-center justify-center
                      sm:w-10 sm:h-10
                      w-10 h-10
                      rounded-full
                      sm:rounded-full
                     
                      transition-all duration-200
                      hover:bg-[#FCEDF3] hover:border hover:border-[#771237] text-[#771237]

                      ${
                        activeIcon
                          ? "bg-[#FCEDF3]  border border-[#771237] text-[#771237]"
                          : "sm:border-transparent"
                      }
                    `}
                >
                  <Img
                    className="h-6 w-6"
                    src="/images/new-globe.svg"
                    alt="search"
                  />
                    <div
                      className=" text-black-900 text-sm cursor-pointer mt-[2px] relative"
                      size="txtnunitoRegular14Black900"
                      onClick={handlelanguage}
                    >
                      <div
                        className={`${enStyles} absolute left-auto top-[30px] -right-10 z-50 before-click`}
                      >
                        <div className="w-auto flex flex-row bg-white-A700 shadow-md mx-auto">
                          <div className="flex flex-col py-2 w-full">
                            <ul className="flex flex-col">
                              <li
                                className="flex items-center gap-2 px-4 py-2 text-black-900 hover:bg-gray-50_02 hover:text-pink-800"
                                onClick={(e) => {
                                  localStorage.setItem(
                                    "jsahdjkanbn",
                                    "sd542s3ad2sa1d3iu748923DSF"
                                  );
                                  i18n.changeLanguage("en");
                                  let defaultLanguage = "ltr";
                                  document.documentElement.setAttribute(
                                    "dir",
                                    defaultLanguage
                                  );
                                  if (props?.cpage == "/cart") {
                                    dispatch(changeTrigger("updateinlocal_langChg"));
                                  }
                                  setTimeout(() => {
                                    if (props?.cpage == "/cart") {
                                      const url = new URL(window.location.href);
                                      url.searchParams.set("lang", "1");
                                      window.history.pushState(
                                        {},
                                        "",
                                        url.toString()
                                      );
                                    }
                                    window.location.reload();
                                  }, 500);
                                }}
                              >
                                <Img
                                  className="h-6 object-contain w-6 min-w-[1.5rem]"
                                  src="/images/flag-eng.svg"
                                  alt="rabbitholelogo"
                                />
                                <Text className="whitespace-nowrap font-nunitoregular font-normal text-base leading-6 -mt-1 self-center">
                                  English
                                </Text>
                              </li>
                              <li
                                className="flex items-center gap-2 px-4 py-2 text-black-900 hover:bg-gray-50_02 hover:text-pink-800"
                                onClick={(e) => {
                                  localStorage.setItem(
                                    "jsahdjkanbn",
                                    "sd5s42s3ad2sa1d3iu748923DSF"
                                  );
                                  i18n.changeLanguage("ar");
                                  let defaultLanguage = "rtl";
                                  document.documentElement.setAttribute(
                                    "dir",
                                    defaultLanguage
                                  );
                                  if (props?.cpage == "/cart") {
                                    dispatch(changeTrigger("updateinlocal_langChg"));
                                  }
                                  setTimeout(() => {
                                    if (props?.cpage == "/cart") {
                                      const url = new URL(window.location.href);
                                      url.searchParams.set("lang", "1");
                                      window.history.pushState(
                                        {},
                                        "",
                                        url.toString()
                                      );
                                    }
                                    window.location.reload();
                                  }, 500);
                                }}
                              >
                                <Img
                                  className="h-6 object-contain w-6 min-w-[1.5rem]"
                                  src="/images/flag-arb.svg"
                                  alt="rabbitholelogo"
                                />
                                <Text className="whitespace-nowrap font-nunitoregular font-normal	text-base leading-6 -mt-1 self-center">
                                  عربي
                                </Text>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                </span>

                <Img
                  className="h-6 w-6 cursor-pointer   hover:text-[#771237]  "
                  src="/images/img_search.svg"
                  alt="search"
                  onClick={() => navigate("/search")}
                />

                  <div className="relative inline-block">
                    <Img
                      className="h-6 w-6 cursor-pointer   hover:text-[#771237]"
                      src="/images/new-cart.svg"
                      alt="Add to cart"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/cart")}}
                    />
                    {cartCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-[#FDF2F6] text-white font-nunitomedium text-[11px] rounded-[10px] min-w-[18px] h-[18px] px-1 flex items-center justify-center leading-none">
                        {cartCount > 99 ? '99+' : cartCount}
                      </span>
                    )}
                  </div>
                 <button
                  className={`${hamburgerStyles} hamburger hamburger--slider hidden sm:flex`}
                  type="button"
                  onClick={handlehamburger}
                >
                  <span className="hamburger-box">
                    <span className="hamburger-inner"></span>
                  </span>
                </button>
                {/* <Img
                  className="h-6 w-6 cursor-pointer hidden sm:block hover:text-[#771237]"
                  src="/images/new-menu.svg"
                  alt="search"
                  onClick={handlehamburger}
                /> */}
                {!isLoggedIn ? (
                <Button
                  className="
                    sm:hidden
                    flex items-center justify-center gap-[10px]
                    h-[48px]
                    border border-[#E6E6E6]
                    bg-white
                    p-2
                    rounded-full
                    text-[#1A1A1A]
                    font-[Unbounded] font-medium
                    text-[16px] 
                    transition-all duration-300 ease-in-out
                    hover:bg-[#1A1A1A]
                    hover:text-[#FFFFFF]
                  "
                  onClick={() => navigate("/login")}
                >
                  {t("Signup_Login")}
                </Button>
                ) : (
                  <div className="relative sm:hidden group">
                    <div
                      className="
                        cursor-pointer
                        flex items-center gap-2
                        text-[black]
                        font-[Inter]
                        font-medium
                      "
                    >
                      Welcome , {userName}
                      <svg
                        className="w-4 h-4 transition-transform group-hover:rotate-180"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>

                    {/* Dropdown */}
                    <div
                      className="
                        absolute
                        right-0
                        top-full
                        mt-2
                        w-[120px]
                        bg-white
                        border
                        border-[#E6E6E6]
                        rounded-lg
                        shadow-md
                        opacity-0
                        invisible
                        group-hover:opacity-100
                        group-hover:visible
                        transition-all
                        duration-200
                        z-50
                      "
                    >
                      <button
                        onClick={handleLogout}
                        className="
                          w-full
                          h-10
                          text-left
                          font-[Inter]
                          bg-[#FFFFFF]
                          px-4
                          py-2
                          text-[14px]
                          font-medium
                          text-[#771237]
                          hover:bg-[#FCEDF3]
                          rounded-lg
                        "
                      >
                        {t("Logout")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          {/* // ) : null} */}
        </div>
      </header>
      <Outlet />
    </>
  );
};

Header.defaultProps = {};

export default Header;
